import React, { useState } from 'react';
import { SHOW_USDT_WITHDRAW_MENU } from './featureFlags';
import adaboCashLogo from './image/adabo_cash_logo.png';
import mvolaLogo from './image/mvola-logo.png';
import orangeMoneyLogo from './image/orange-money.jpg';
import './css/home.css';

const Icon = ({ name, size = 20 }) => {
  const paths = {
    arrow: <><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></>,
    card: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /><path d="M7 15h3" /></>,
    shield: <><path d="M12 3 4.5 6v5c0 4.8 3.2 8.2 7.5 10 4.3-1.8 7.5-5.2 7.5-10V6L12 3Z" /><path d="m9 12 2 2 4-4" /></>,
    swap: <><path d="M7 7h12l-3-3" /><path d="m19 7-3 3" /><path d="M17 17H5l3 3" /><path d="m5 17 3-3" /></>,
    phone: <><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></>,
    globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3.4 3 14.6 0 18M12 3c-3 3.4-3 14.6 0 18" /></>,
    support: <><path d="M4 13v-2a8 8 0 0 1 16 0v2" /><path d="M4 13h3v6H5a1 1 0 0 1-1-1v-5ZM20 13h-3v6h2a1 1 0 0 0 1-1v-5ZM17 19c0 1.1-2.2 2-5 2" /></>,
    check: <path d="m5 12 4 4L19 6" />,
    menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
    close: <><path d="m6 6 12 12M18 6 6 18" /></>,
    lock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
    trend: <><path d="m4 16 5-5 4 4 7-8" /><path d="M15 7h5v5" /></>,
  };

  return (
    <svg className="ui-icon" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true">
      {paths[name]}
    </svg>
  );
};

const Brand = ({ inverse = false }) => (
  <div className={`brand ${inverse ? 'brand--inverse' : ''}`}>
    <img className="brand-logo" src={adaboCashLogo} alt="" aria-hidden="true" />
    <span className="brand-text">Adabo Cash</span>
  </div>
);

const DashboardPreview = () => (
  <div className="dashboard-scene" aria-label="Aperçu des services financiers Adabo Cash">
    <div className="dashboard-glow dashboard-glow--one" />
    <div className="dashboard-glow dashboard-glow--two" />
    <div className="finance-visual">
      <section className="finance-balance-card">
        <div className="finance-card-head">
          <div>
            <span>Solde total</span>
            <strong>2 450 000 <small>Ar</small></strong>
          </div>
          <span className="finance-visibility">◉</span>
        </div>
        <div className="finance-meta">
          <span><i className="live-dot" /> Mis à jour à l'instant</span>
          <div><b>7J</b><b className="active">30J</b><b>3M</b></div>
        </div>
        <div className="finance-chart">
          <span className="chart-y top">3M</span>
          <span className="chart-y middle">2M</span>
          <span className="chart-y bottom">1M</span>
          <i className="chart-grid grid-one" />
          <i className="chart-grid grid-two" />
          <i className="chart-grid grid-three" />
          <svg viewBox="0 0 520 150" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0 131 C35 126 48 92 78 98 S122 117 154 75 205 93 238 48 291 72 325 38 368 100 404 65 449 81 520 25" />
            <circle cx="520" cy="25" r="5" />
          </svg>
        </div>
        <div className="finance-chart-labels"><span>Lun</span><span>Mer</span><span>Ven</span><span>Aujourd'hui</span></div>
      </section>

      <section className="finance-activity-card">
        <div className="finance-section-head"><strong>Activité récente</strong><span>Voir tout</span></div>
        <div className="finance-activity-row">
          <span className="finance-row-icon deposit">↓</span>
          <div><strong>Dépôt MVola</strong><small>Aujourd'hui · 10:42</small></div>
          <b className="positive">Reçu</b>
        </div>
        <div className="finance-activity-row">
          <span className="finance-row-icon card"><Icon name="card" size={13} /></span>
          <div><strong>Carte virtuelle</strong><small>Hier · Paiement</small></div>
          <b>Validé</b>
        </div>
        <div className="finance-activity-row">
          <span className="finance-row-icon exchange">⇄</span>
          <div><strong>Échange USDT</strong><small>Hier · 16:08</small></div>
          <b className="positive">Terminé</b>
        </div>
      </section>

      <section className="finance-usdt-card">
        <div className="finance-section-head"><strong>Portefeuille USDT</strong><span>TRC20</span></div>
        <div className="finance-usdt-title">
          <span className="usdt-mark">₮</span>
          <div><strong>USDT disponible</strong><small>Portefeuille actif et sécurisé</small></div>
        </div>
        <div className="finance-progress"><i /></div>
        <div className="finance-status"><span>Prêt à échanger</span><b>Actif</b></div>
      </section>

      <section className="finance-insight-card">
        <span><Icon name="trend" size={18} /></span>
        <div><strong>Tout est sous contrôle</strong><small>Suivez vos opérations en temps réel.</small></div>
        <Icon name="arrow" size={17} />
      </section>

      <div className="finance-virtual-card">
        <div className="finance-vc-brand"><img src={adaboCashLogo} alt="" /><span>ADABO CASH</span></div>
        <div className="finance-vc-chip" />
        <strong>•••• &nbsp;•••• &nbsp;8429</strong>
        <div><span>CARTE VIRTUELLE</span><b>VISA</b></div>
      </div>
    </div>
  </div>
);

const HomePage = ({ onLogin, onRegister, onGetStarted }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="home-page">
      <header className="site-header">
        <div className="home-container header-inner">
          <a className="brand-link" href="#top" aria-label="Adabo Cash, accueil" onClick={closeMenu}><Brand /></a>
          <nav className={`site-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Navigation principale">
            <a href="#services" onClick={closeMenu}>Services</a>
            <a href="#payments" onClick={closeMenu}>Paiements</a>
            <a href="#security" onClick={closeMenu}>Sécurité</a>
            <a href="#about" onClick={closeMenu}>À propos</a>
          </nav>
          <div className="header-actions">
            <button className="text-button" onClick={onLogin}>Se connecter</button>
            <button className="primary-button compact" onClick={onRegister}>Créer un compte</button>
          </div>
          <button className="menu-button" type="button" aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
            <Icon name={menuOpen ? 'close' : 'menu'} size={24} />
          </button>
        </div>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero-orb hero-orb--left" />
          <div className="hero-orb hero-orb--right" />
          <div className="home-container hero-layout">
            <div className="hero-copy">
              <span className="eyebrow"><i /> La finance digitale, pensée pour Madagascar</span>
              <h1>Votre argent.<br /><em>Sans frontières.</em></h1>
              <p className="hero-lead">
                Cartes virtuelles, dépôts en Ariary et échange USDT réunis dans une expérience simple,
                rapide et sécurisée.
              </p>
              <div className="hero-actions">
                <button className="primary-button large" onClick={onGetStarted}>
                  Ouvrir un compte <Icon name="arrow" size={18} />
                </button>
                <a className="outline-button large" href="#services">Découvrir la plateforme</a>
              </div>
              <div className="trust-line">
                <span className="trust-icon"><Icon name="shield" size={18} /></span>
                <p><strong>Transactions protégées</strong><small>Contrôles de sécurité multicouches</small></p>
              </div>
            </div>
            <DashboardPreview />
          </div>
          <div className="home-container proof-bar">
            <div><Icon name="card" /><span><strong>Cartes virtuelles</strong><small>Création instantanée</small></span></div>
            <div><Icon name="swap" /><span><strong>MGA ↔ USDT</strong><small>Taux en temps réel</small></span></div>
            <div><Icon name="globe" /><span><strong>24h/24, 7j/7</strong><small>Disponible partout</small></span></div>
            <div><Icon name="lock" /><span><strong>Sécurité avancée</strong><small>Protection multicouche</small></span></div>
          </div>
        </section>

        <section className="community-proof" aria-label="Communauté Adabo Cash">
          <div className="home-container community-proof-inner">
            <div className="community-avatars" aria-hidden="true">
              <span>MA</span><span>TN</span><span>JR</span><span>+</span>
            </div>
            <div className="community-copy">
              <span className="section-kicker">Une communauté qui grandit</span>
              <h2>Déjà plus de 10 000 utilisateurs nous font confiance.</h2>
              <p>Des particuliers et entrepreneurs utilisent Adabo Cash pour gérer leurs paiements numériques au quotidien.</p>
            </div>
            <div className="community-count">
              <strong>10K<sup>+</sup></strong>
              <span>utilisateurs</span>
              <small><i /> Communauté active</small>
            </div>
          </div>
        </section>

        <section className="section services" id="services">
          <div className="home-container">
            <div className="section-heading">
              <span className="section-kicker">Une seule plateforme</span>
              <h2>Tout ce qu'il faut pour avancer</h2>
              <p>Des services financiers numériques conçus pour être clairs, rapides et accessibles.</p>
            </div>
            <div className="service-grid">
              <article className="service-feature service-feature--dark">
                <div className="service-icon"><Icon name="card" size={26} /></div>
                <span className="card-label">CARTES VIRTUELLES</span>
                <h3>Achetez en ligne avec plus de contrôle.</h3>
                <p>Créez et gérez une carte virtuelle pour vos achats, abonnements et paiements internationaux.</p>
                <ul>
                  <li><Icon name="check" /> Création instantanée</li>
                  <li><Icon name="check" /> Contrôle des dépenses en temps réel</li>
                  <li><Icon name="check" /> Acceptation mondiale</li>
                  <li><Icon name="check" /> Sécurité avancée</li>
                </ul>
                <button onClick={onGetStarted}>Créer une carte <Icon name="arrow" /></button>
                <div className="mini-card">
                  <div className="mini-card-top"><span>ADABO CASH</span><b>VISA</b></div>
                  <i className="mini-card-chip" />
                  <strong>•••• &nbsp;•••• &nbsp;8429</strong>
                  <div className="mini-card-bottom"><span>CARTE VIRTUELLE</span><em>12/28</em></div>
                </div>
              </article>

              <article className="service-feature service-feature--light">
                <div className="service-icon"><Icon name="swap" size={26} /></div>
                <span className="card-label">ÉCHANGE USDT</span>
                <h3>Passez de l'Ariary à l'USDT simplement.</h3>
                <p>Convertissez vos MGA en USDT avec des taux transparents et une exécution rapide.</p>
                <div className="usdt-exchange-preview">
                  <div className="exchange-preview-head">
                    <strong>Échange MGA → USDT</strong>
                    <span><i /> En direct</span>
                  </div>
                  <div className="exchange-currency-row">
                    <span className="currency-mark mga">Ar</span>
                    <div><small>Vous envoyez</small><strong>Ariary malgache</strong></div>
                    <b>MGA</b>
                  </div>
                  <span className="exchange-switch">⇅</span>
                  <div className="exchange-currency-row">
                    <span className="currency-mark usdt">₮</span>
                    <div><small>Vous recevez</small><strong>Tether</strong></div>
                    <b>USDT</b>
                  </div>
                  <div className="exchange-preview-note"><Icon name="shield" size={14} /> Taux, frais et montant final confirmés avant validation</div>
                </div>
                <ul>
                  <li><Icon name="check" /> Taux en temps réel</li>
                  <li><Icon name="check" /> Frais réduits</li>
                  {SHOW_USDT_WITHDRAW_MENU && <li><Icon name="check" /> Retraits USDT sécurisés</li>}
                  <li><Icon name="check" /> Service disponible 24h/24</li>
                </ul>
                <button onClick={onGetStarted}>Commencer l'échange <Icon name="arrow" /></button>
              </article>
            </div>
          </div>
        </section>

        <section className="section payments" id="payments">
          <div className="home-container payment-layout">
            <div className="payment-copy">
              <span className="section-kicker">Paiements locaux</span>
              <h2>Déposez comme vous en avez l'habitude.</h2>
              <p>Alimentez votre compte en Ariary avec les services Mobile Money les plus utilisés à Madagascar.</p>
              <div className="payment-points">
                <span><Icon name="check" /> Confirmation rapide par SMS</span>
                <span><Icon name="check" /> Dépôts disponibles 24h/24</span>
                <span><Icon name="check" /> Assistance client dédiée</span>
              </div>
            </div>
            <div className="payment-options">
              <article>
                <span className="payment-logo"><img src={mvolaLogo} alt="MVola" /></span>
                <div><strong>MVola</strong><small>Dépôts instantanés et sécurisés</small></div>
                <Icon name="arrow" />
              </article>
              <article>
                <span className="payment-logo"><img src={orangeMoneyLogo} alt="Orange Money" /></span>
                <div><strong>Orange Money</strong><small>Simple, rapide et sans détour</small></div>
                <Icon name="arrow" />
              </article>
              <div className="payment-note"><Icon name="shield" /><span><strong>Vos données restent protégées</strong><small>Chaque opération est vérifiée avant validation.</small></span></div>
            </div>
          </div>
        </section>

        <section className="section security" id="security">
          <div className="home-container">
            <div className="section-heading">
              <span className="section-kicker">Pourquoi Adabo Cash</span>
              <h2>La simplicité, sans compromis.</h2>
            </div>
            <div className="benefit-grid">
              <article><span><Icon name="shield" /></span><h3>Sécurité bancaire</h3><p>Vos données et vos fonds sont protégés par plusieurs niveaux de contrôle.</p></article>
              <article><span><Icon name="trend" /></span><h3>Rapide par nature</h3><p>Suivez vos opérations et gérez votre argent depuis un tableau de bord fluide.</p></article>
              <article><span><Icon name="globe" /></span><h3>Accessible partout</h3><p>Accédez à vos cartes et à vos USDT où que vous soyez, à tout moment.</p></article>
              <article><span><Icon name="support" /></span><h3>Support humain</h3><p>Une équipe disponible pour vous accompagner à chaque étape.</p></article>
            </div>
          </div>
        </section>

        <section className="section steps">
          <div className="home-container">
            <div className="section-heading">
              <span className="section-kicker">Comment ça marche</span>
              <h2>Prêt en trois étapes.</h2>
            </div>
            <div className="step-grid">
              <article><span>01</span><h3>Créez votre compte</h3><p>Inscrivez-vous et vérifiez votre identité pour protéger votre accès.</p></article>
              <article><span>02</span><h3>Ajoutez des fonds</h3><p>Déposez des MGA avec MVola ou Orange Money.</p></article>
              <article><span>03</span><h3>Gérez et échangez</h3><p>Créez vos cartes, achetez des USDT et suivez chaque transaction.</p></article>
            </div>
          </div>
        </section>

        <section className="section about" id="about">
          <div className="home-container about-layout">
            <div>
              <span className="section-kicker">À propos</span>
              <h2>Une finance numérique plus proche des Malgaches.</h2>
            </div>
            <div className="about-copy">
              <p>Adabo Cash est une plateforme financière basée à Madagascar. Notre mission est de démocratiser l'accès aux cartes virtuelles et aux actifs numériques grâce à une expérience sûre et accessible.</p>
              <p>Nous relions les habitudes locales — notamment MVola et Orange Money — aux possibilités de l'économie mondiale, pour faciliter les achats en ligne et l'échange de cryptomonnaies.</p>
              <div className="about-facts">
                <span><strong>100%</strong><small>Expérience digitale</small></span>
                <span><strong>24/7</strong><small>Accès à la plateforme</small></span>
                <span><strong>2022</strong><small>Année de création</small></span>
              </div>
            </div>
          </div>
        </section>

        <section className="cta">
          <div className="cta-orb" />
          <div className="home-container cta-inner">
            <span className="section-kicker">Passez à l'action</span>
            <h2>Votre argent mérite une meilleure expérience.</h2>
            <p>Créez votre compte Adabo Cash et prenez le contrôle de vos paiements numériques.</p>
            <div className="cta-buttons">
              <button className="light-button" onClick={onGetStarted}>Créer mon compte <Icon name="arrow" /></button>
              <button className="ghost-button" onClick={onLogin}>J'ai déjà un compte</button>
            </div>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="home-container footer-grid">
          <div className="footer-brand"><Brand inverse /><p>Cartes virtuelles et échange USDT, conçus pour Madagascar.</p></div>
          <div><h3>Services</h3><a href="#services">Cartes virtuelles</a><a href="#services">Échange USDT</a>{SHOW_USDT_WITHDRAW_MENU && <a href="#services">Retrait USDT</a>}<a href="#payments">Méthodes de paiement</a></div>
          <div><h3>Entreprise</h3><a href="#about">À propos</a><a href="#security">Sécurité</a><a href="https://m.me/adabocash" target="_blank" rel="noreferrer">Nous contacter</a></div>
          <div><h3>Contact</h3><a href="https://m.me/adabocash" target="_blank" rel="noreferrer">Messenger · @adabocash</a><a href="https://t.me/adabocash_bot" target="_blank" rel="noreferrer">Telegram · @adabocash_bot</a><a href="mailto:adabocash@gmail.com">adabocash@gmail.com</a><span>038 09 541 68 · 032 45 625 71</span></div>
        </div>
        <div className="home-container footer-bottom">
          <span>© 2026 Adabo Cash. Tous droits réservés.</span>
          <span>NIF 3002815502 · STAT 47912 11 2017 0 05806</span>
          <span><Icon name="shield" size={16} /> Plateforme sécurisée</span>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
